import type { PartnerTotalRevenueSummary } from "@/types/partner-dashboard";

/**
 * Hotel Brands "Total Revenue from Partners" card: the tenant's commission
 * from partner bookings (earned + expected, cancelled and refunded excluded),
 * as the tenant total-revenue endpoint returns `totalRevenue` (DV-68). The
 * guest price is `totalBooked`. Missing or malformed data is null and renders
 * as "—".
 */
export function resolvePartnerRevenue(
  summary: Pick<PartnerTotalRevenueSummary, "totalRevenue"> | null | undefined,
): number | null {
  const value = summary?.totalRevenue;
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function formatPartnerRevenueEur(value: number | null): string {
  return value === null ? "—" : `€${value.toLocaleString("en-GB")}`;
}
